import React from 'react';
import styled from "styled-components";
import Text, {TextGold, TextGoldRepeat} from '../styledComponents/TextStyled'
import * as MdIcons from 'react-icons/md'
import {IconMaquinas} from './Icons'
import {DateTime} from 'luxon';
import {parseDateTime} from '../util/dateUtils';

export const CardWinnerContainer = styled.div`
    width: 100%;
    height: calc(85vh - 2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
    flex-direction: column;
    text-align: center;
    transition: all 0.5s ease;
    color: white;
    -webkit-user-select: none;
    user-select: none;
    @media (max-height: 600px) {
        transition: all 0.5s ease;
        height: calc(85vh - 1rem);
    }
`

export const ContainerText = styled.div`
    display: flex;
    flex-direction: ${props => props.$flexDirection || "column"};
    gap: 16px;
    align-items: center;
`


export default function CardWinner(props) {
  const hasWinnerData = Boolean(
    props.winnerName ||
    props.winnerDocument ||
    props.couponCode ||
    props.machine
  );

  function getWinnerName() {
    return props.winnerName || 'CLIENTE ANONIMO'
  }

  function getCouponHour(datetime) {
    const couponDate = parseDateTime(datetime)
    return couponDate ? couponDate.toFormat("hh:mm a") : ''
  }

  function getCouponDate(datetime) {
    const couponDate = parseDateTime(datetime)
    if (!couponDate) {
      return ''
    }

    const today = DateTime.now().startOf('day')
    if (today > couponDate.startOf('day')) {
      return couponDate.setLocale('es').toFormat("dd 'de' MMMM");
    }

    return ''
  }

  return (
    <CardWinnerContainer>
      {hasWinnerData &&
        <>
          <TextGold textStyle='xlarge'>FELICIDADES</TextGold>
          <ContainerText>
            <Text textStyle='xlarge'>{getWinnerName()}</Text>
            {props.winnerDocument &&
              <Text textStyle='xlarge'>{(props.winnerDocumentTypeName || 'documento') + ": " + props.winnerDocument}</Text>
            }
          </ContainerText>
          <ContainerText>
            <Text>ES NUESTRO</Text>
            <TextGoldRepeat textStyle='xlarge'>¡GANADOR(A)!</TextGoldRepeat>
          </ContainerText>
          <ContainerText>
              {props.couponCode &&
                <ContainerText $flexDirection='row'>
                  <Text textStyle='xlarge'>CUPÓN: {props.couponCode}</Text>
                  <MdIcons.MdLocalPlay fontSize={54}/>
                </ContainerText>
              }

              <ContainerText $flexDirection='row' style={{gap: '128px'}}>
                {props.machine &&
                  <ContainerText $flexDirection='row'>
                    <Text textStyle='xlarge'>Máquina: {props.machine}</Text>
                    <IconMaquinas fontSize={'54px'}/>
                  </ContainerText>
                }
                {props.couponCreatedAt &&
                  <ContainerText style={{gap: '0px'}}>
                    <ContainerText $flexDirection='row'>
                      <Text textStyle='xlarge'>{getCouponHour(props.couponCreatedAt)}</Text>
                      <MdIcons.MdOutlineAccessTime fontSize={54}/>
                    </ContainerText>
                    <Text textStyle='large'>{getCouponDate(props.couponCreatedAt)}</Text>
                  </ContainerText>
                }
              </ContainerText>

            </ContainerText>
        </>
      }
    </CardWinnerContainer>
  );
}
